
import { ChurchPresence } from '../data/types/region-types';

export const getPresenceColor = (presence: string) => {
  switch (presence?.toUpperCase()) {
    case 'GOOD':
      return '#0000FF'; // Blue for good presence
    case 'LOW':
      return '#FFC0CB'; // Pink for low presence
    case 'UNREACHED':
      return '#FF4C4C'; // Red for unreached areas
    default:
      return '#CCCCCC'; // Gray for unknown
  }
};

export const getPresenceText = (presence: string, t: (key: string) => string) => {
  return presence?.toUpperCase() === 'LOW' ? t('low') : t('other');
};

export const normalizePresence = (presence: string): ChurchPresence => {
  const normalized = presence.charAt(0).toUpperCase() + presence.slice(1).toLowerCase();
  return normalized as ChurchPresence;
};

// NEW: Get presence color for mapbox display
export const getMapPresenceColor = (presence: string) => {
  switch (presence?.toLowerCase()) {
    case 'good':
      return '#0000FF'; // Blue
    case 'low':
      return '#F97316'; // Orange
    case 'unreached':
      return '#EF4444'; // Red
    case 'medium':
      return '#FACC15'; // Yellow
    case 'high':
      return '#22C55E'; // Green
    default:
      return '#94A3B8'; // Gray
  }
};

// NEW: Get a background value for the presence to use in styling
export const getPresenceBackground = (presence: string) => {
  switch (presence?.toLowerCase()) {
    case 'unreached':
      return 'bg-red-500';
    case 'low':
      return 'bg-orange-500';
    case 'medium':
      return 'bg-yellow-500';
    case 'good':
    case 'high':
      return 'bg-green-500';
    default:
      return 'bg-gray-400';
  }
};
